import { render, staticRenderFns } from "./Advertisements.vue?vue&type=template&id=2de2bbbb&"
import script from "./Advertisements.vue?vue&type=script&lang=js&"
export * from "./Advertisements.vue?vue&type=script&lang=js&"
import style0 from "./Advertisements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports